import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-document-sync-toolbar',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, TranslateModule],
  templateUrl: './document-sync-toolbar.component.html',
  styleUrl: './document-sync-toolbar.component.scss',
})
export class DocumentSyncToolbarComponent {
  @Input() updatedLabel = '';
  @Input() canSync = false;
  @Input() isSyncing = false;
  @Output() syncRequested = new EventEmitter<void>();

  onSyncClick(): void {
    if (!this.canSync || this.isSyncing) {
      return;
    }
    this.syncRequested.emit();
  }
}
